module.exports = __webpack_public_path__ + "static/AntroVectra-Bolder-038603f8f2c39567734c90fa38be423a.otf";